import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './BookingConfirmation.css';
import Swal from "sweetalert2";
import { useUser } from '../context/UserContext';
import { fireAudit } from '../utils/auditClient';
const BookingConfirmation = ({ bookingDetails, onBookingSuccess }) => {
  const location = useLocation();

  const { sportId, date, academyId, courtTimingIds, guestCount } = bookingDetails || {};
  const [academyName, setAcademyName] = useState('');
  const { selectedCenter } = useUser();
  const [bookingDate, setBookingDate] = useState('');
  const token = localStorage.getItem('auth-token');
  const [price, setPrice] = useState(0);
  const [gstPrice, setGstPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [courts, setCourts] = useState([]);
  const [userName, setUserName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [methodAmounts, setMethodAmounts] = useState({});
  const [collectionMethod, setCollectionMethod] = useState('');
  const [discountAmount, setDiscountAmount] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [collectionMethods, setPaymentMethods] = useState([]);
  const auditRedact = (obj) => {
    if (!obj || typeof obj !== 'object') return obj;
    const SENSITIVE_KEYS = ['phone', 'mobile', 'mobileNumber', 'userMobileNumber', 'username', 'email', 'upi', 'upiId', 'pan', 'gst', 'aadhaar', 'password'];
    const mask = (v) => (typeof v === 'string' && v.length ? '********' : v);
    const clone = Array.isArray(obj) ? [] : {};
    for (const [k, v] of Object.entries(obj)) {
      if (SENSITIVE_KEYS.includes(k)) {
        clone[k] = mask(v);
      } else if (k.toLowerCase().includes('url') && typeof v === 'string') {
        try {
          const u = new URL(v);
          clone[k] = `${u.origin}/********`;
        } catch {
          clone[k] = '********';
        }
      } else if (v && typeof v === 'object') {
        clone[k] = auditRedact(v);
      } else {
        clone[k] = v;
      }
    }
    return clone;
  };

  useEffect(() => {
    if (mobileNumber.length === 10) {
      const formattedMobileNumber = `+91${mobileNumber}`;

      const apiUrl = `${process.env.REACT_APP_API_PLAYER_SEARCH}?academyId=${selectedCenter}&mobileNumber=${mobileNumber}`;

      const fetchUser = async () => {
        try {
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          };

          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: headers,
          });

          const data = await response.json();

          if (data && data.data && data.data.searchData) {
            const user = data.data.searchData.find(item => item.mobile_number === formattedMobileNumber);

            if (user) {

              setUserName(user.name);
            } else {

              setUserName('');
            }
          } else {

            setUserName('');
          }
        } catch (error) {

          setUserName('');
        }
      };

      fetchUser();
    }
  }, [mobileNumber, selectedCenter]);




  useEffect(() => {
    if (!bookingDetails) {
      setError('Booking details not available');
      return;
    }

    const fetchSlotDetails = async () => {
      try {
        const { sportId, date, academyId, courtTimingIds } = bookingDetails;
        if (!sportId || !date || !academyId || !courtTimingIds?.length) {
          throw new Error('Invalid booking details');
        }
        const selectedSlots = courtTimingIds.join(',');
        let apiUrl = '';

        if (sportId === 11) {
          apiUrl = `${process.env.REACT_APP_API_COURT_SLOT_DETAILS}?guestCount=${guestCount}&selectedSlots=${selectedSlots}&date=${date}&sportId=${sportId}&academyId=${academyId}`;
        } else {
          apiUrl = `${process.env.REACT_APP_API_COURT_SLOT_DETAILS}?selectedSlots=${selectedSlots}&date=${date}&sportId=${sportId}&academyId=${academyId}`;
        }


        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        };

        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: headers,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        const errorMessage = data?.data?.details?.data?.errorMessage;

        if (errorMessage) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: errorMessage,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
        if (data.success) {
          const slotDetails = data.data.details.data.courtBookingForm;

          setAcademyName(slotDetails.academyName);
          setBookingDate(new Date(slotDetails.date).toLocaleDateString());
          setPrice(slotDetails.price);
          setGstPrice(slotDetails.gstPrice);
          setTotalPrice(slotDetails.totalPrice);


          const courtDetails = slotDetails.courtAndTimingDtos.map(court => ({
            name: court.courtName,
            timeslots: [court.displayTIme],
            courtId: court.courtId,
            courtTimingId: court.courtTimingId,
            startTime: court.startTime,
            endTime: court.endTime,
          }));
          setCourts(courtDetails);
          const availablePaymentMethods = data.data.details.data.paymentMethodOffline;
          setPaymentMethods(availablePaymentMethods);
        } else {
          throw new Error(data.success_message || 'Failed to fetch slot details');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };


    fetchSlotDetails();
  }, [bookingDetails]);

  const handleConfirmBooking = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    if (!userName || !mobileNumber) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Name and Mobile Number are required!",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      setIsSubmitting(false);
      return;
    }
    if (mobileNumber.length !== 10) {
      Swal.fire({
        icon: "error",
        title: "Invalid Mobile Number",
        text: "Please enter a valid 10-digit mobile number.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      setIsSubmitting(false);
      return;
    }

    const razorpayAmount = parseFloat(methodAmounts["Razorpay_QR_Link"]) || 0;
    const cashAmount = parseFloat(methodAmounts["CASH"]) || 0;
    const venueQRAmount = parseFloat(methodAmounts["VENUE_QR"]) || 0;

    const totalAmount = discountAmount + razorpayAmount + cashAmount + venueQRAmount;

    if (totalAmount <= 0) {
      Swal.fire({
        icon: "error",
        title: "Payment Required",
        text: "Please Enter Amount",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      setIsSubmitting(false);
      return;
    }


    const formatTime12Hour = (timeStr) => {
      const [hour, minute] = timeStr.split(':');
      const date = new Date();
      date.setHours(parseInt(hour), parseInt(minute));
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    };
    const normalizedAmounts = Object.fromEntries(
      Object.entries(methodAmounts).map(([key, value]) => [key.toLowerCase().replace(/\s+/g, '_'), value])
    );

    const payload = {
      academyId: Number(academyId),
      academyName: academyName,
      date: date,
      price: price,
      gstPrice: gstPrice,
      totalPrice: discountAmount > 0 ? totalPrice - discountAmount : totalPrice,
      username: userName,
      discount: discountAmount > 0 ? totalPrice - discountAmount : totalPrice,
      userMobileNumber: mobileNumber,
      courtAndTimingDtos: courts.map(court => ({
        academyId: Number(academyId),
        sportId: sportId,
        courtId: court.courtId,
        startTime: court.startTime,
        endTime: court.endTime,
        courtTimingId: court.courtTimingId,
        displayTIme: `${formatTime12Hour(court.startTime)} - ${formatTime12Hour(court.endTime)}`,
        sport: {
          id: sportId,
          name: ""
        },
        courtName: court.name,
      })),
      paymentMethodOffline: "Razorpay_QR_Link",
      razorpay: Number(methodAmounts["Razorpay_QR_Link"] || 0),
      cash: Number(methodAmounts["CASH"] || 0),
      venueQr: Number(methodAmounts["VENUE_QR"] || 0),
      guestCount: typeof guestCount === "number" ? Math.max(guestCount - 1, 0) : 0

    };

    try {
      const response = await fetch(process.env.REACT_APP_API_BOOK_COURT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json(); 

      if (response.ok && data.success) {
        fireAudit({
          entity: 'booking',
          affected_id: data?.data?.bookingId || data?.data?.id || data?.id || null,
          action: 'create',
          businessApi: process.env.REACT_APP_API_BOOK_COURT,
          businessMethod: 'POST',
          oldPayload: null,
          newPayload: auditRedact(payload),
          section: 'Court Booking',
          subSection: 'Booking Calendar',
          extra: { page: 'BookingConfirmation' }
        });
        onBookingSuccess();
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Court booking confirmed!",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        setIsSubmitting(false);
      } else {
        const errorMsg = data?.data?.errorMessage || data?.message || `Booking failed (code ${response.status})`;
        throw new Error(errorMsg);
      }
    } catch (error) {
      console.error("Booking error:", error.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      setIsSubmitting(false);
    } finally {
      setIsSubmitting(false);
    }
  };
  const getDisplayName = (method) => {
    const mapping = {
      Razorpay_QR_Link: 'Via Razorpay',
      VENUE_QR: 'Venue QR',
      CASH: 'Cash',
    };
    return mapping[method] || method;
  };
  useEffect(() => {
    const total = isNaN(totalPrice) ? 0 : totalPrice;
    const methods = ['Razorpay_QR_Link', 'VENUE_QR', 'CASH'];

    const paidAmount = methods.reduce((sum, method) => {
      const val = parseFloat(methodAmounts[method]);
      return sum + (isNaN(val) ? 0 : val);
    }, 0);

    const calculatedDiscount = total - paidAmount;

    setDiscountAmount(Math.max(calculatedDiscount, 0));
  }, [methodAmounts, totalPrice]);



  return (
    <div className="booking-container-confirmation">
      <h2 className="booking-title">Booking Confirmation Details</h2>

      <div className="booking-section-court">
        <h3 className="section-title">Court Details:</h3>
        <table className="court-table">
          <thead>
            <tr>
              <th>Court Name</th>
              <th>Time Slots</th>
            </tr>
          </thead>
          <tbody>
            {courts.map((court, index) => (
              <tr key={index}>
                <td>{court.name}</td>
                <td>
                  <ul className="timeslot-list">
                    {court.timeslots.map((timeslot, idx) => (
                      <li key={idx} className="timeslot">{timeslot}</li>
                    ))}
                  </ul>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="booking-section">
        <p className="amount">Academy:  <span>{academyName}</span></p>
        <p className="amount">Date: <span>{bookingDate}</span></p>
        <p className="amount">Booking Amount: <span>₹{price}</span></p>
        <p className="amount">GST Amount: <span>₹{gstPrice}</span></p>
        <p className="total-amount">Total Amount: <span>₹{totalPrice}</span></p>
        <div className="input-group-court" style={{ width: '96%' }}>
          <label className="user-label">Mobile Number:</label>
          <input
            type="text"
            className="user-input-court"
            placeholder="Enter your phone number"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value.replace(/[^0-9]/g, ''))}
            maxLength={10}
          />
        </div>
        <div className="user-input-container" style={{ width: '96%' }}>
          <div className="input-group-court">
            <label className="user-label">Name:</label>
            <input
              type="text"
              className="user-input-court"
              placeholder="Enter your name"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}

            />
          </div>
        </div>
        <h3 className="section-title" >Collection Method:</h3>
        {collectionMethods.map((method, index) => (
          <div key={index} className="input-group-court" style={{ width: '96%' }}>
            <label className="user-label">{getDisplayName(method)} (₹):</label>
            <input
              type="text"
              className="user-input-court"
              placeholder={`Enter amount for ${method}`}
              value={methodAmounts[method] === 0 ? '0' : methodAmounts[method] || ''}
              onChange={(e) => {
                const value = e.target.value;
                if (value === '' || /^\d+$/.test(value)) {
                  setMethodAmounts((prev) => ({
                    ...prev,
                    [method]: value === '' ? '' : parseInt(value, 10)
                  }));
                }
              }}
            />

          </div>
        ))}
        <div className="input-group-court" style={{ width: '96%' }}>
          <label className="user-label">Discount (₹):</label>
          <input
            type="text"
            className="user-input-court"
            placeholder="Enter discount amount"
            value={discountAmount === 0 ? '' : discountAmount}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || /^\d+$/.test(value)) {
                setDiscountAmount(value === '' ? 0 : parseInt(value, 10));
              }
            }}
          />
        </div>


      </div>
      <button
        className="confirm-booking-btn"
        onClick={handleConfirmBooking}
        disabled={isSubmitting}
      >
        {isSubmitting ? "Booking…" : "Confirm Booking"}
      </button>
    </div>
  );
};

export default BookingConfirmation;